import React, { useMemo } from 'react';
import classNmaes from 'classnames';

type NavigationProps = {
  titleList: string[];
  select: number;
  navOnclick: (index: number) => void;
};

/**
 * @description Navigation Menu
 * @property {string[]} titleList 메뉴 버튼 Text List
 * @property {number} 현재 선택되어있는 Navigation Menu 버튼의 index 번호
 * @property {(index: number) => void} 네비게이션 버튼 온클릭 함수. 선택된 버튼의 인덱스 번호를 넘김
 */
function Navigation({ titleList, select, navOnclick }: NavigationProps) {
  // Navigation Button 생성. 해당 버튼의 index 번호가 select와 일치할 경우 highlight style 적용
  const buttons = useMemo(
    () =>
      titleList.map((value, index) => (
        <div
          key={`nav-btn-${index}`}
          className="nav-btn"
          tabIndex={0}
          onClick={() => navOnclick(index)}
        >
          <p className={classNmaes('text-body', { bold: select === index })}>
            {value}
          </p>
        </div>
      )),
    [navOnclick, select, titleList],
  );

  return <div className="nav">{buttons}</div>;
}

export default Navigation;
